import React from "react";
export default function SVGOil() {
  return (
    <svg x="0px" y="0px" viewBox="0 0 512.001 512.001">
      <g>
        <g fill="#000000">
          <path d="M446.284,175.366L297.276,212.72l-20.961-20.961h-86.449v-21.726h32.619v-29.996h-95.235v29.996h32.619v21.726H0v94.429    h56.425v70.605h234.806l112.817-139.915l33.043-8.283l21.905,21.904l21.21-21.21L446.284,175.366z M56.425,256.192H29.996v-34.436    h26.429V256.192z" />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path d="M503.842,304.725l-34.241-47.084l-34.242,47.084c-12.328,16.953-10.518,40.016,4.305,54.837    c7.997,7.997,18.629,12.401,29.937,12.401s21.94-4.404,29.936-12.401C514.361,344.742,516.171,321.678,503.842,304.725z" />
        </g>
      </g>
    </svg>
  );
}
